// src/pages/Merchandise.js

import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import AddCartButton from '../components/AddCartButton';

const Merchandise = ({ cart, setCart }) => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedType, setSelectedType] = useState('All');

  useEffect(() => {
  fetch(process.env.PUBLIC_URL + '/ProductData.csv')
      .then(response => response.text())
      .then(data => {
        let parsedData = Papa.parse(data, { header: true, dynamicTyping: true }).data;
        // Only keep products with category 'merchandise' (case-insensitive)
        parsedData = parsedData.filter(product => (product.category || '').toLowerCase() === 'merchandise');
        parsedData.forEach(product => {
          if (product.images) {
            product.images = product.images.split('|').map(image => image.trim());
          } else {
            product.images = [];
          }
        });
        setProducts(parsedData);
        setFilteredProducts(parsedData);
      })
      .catch(error => {
        console.error('Error fetching or parsing CSV file:', error);
      });
  }, []);

  const addToCart = (item) => {
    const existingIndex = cart.findIndex(
      cartItem => cartItem.id === item.id && cartItem.type === item.type
    );
    let updatedCart;
    if (existingIndex !== -1) {
      updatedCart = cart.map((cartItem, idx) =>
        idx === existingIndex
          ? { ...cartItem, quantity: (cartItem.quantity || 1) + 1 }
          : cartItem
      );
    } else {
      updatedCart = [...cart, { ...item, quantity: 1 }];
    }
    setCart(updatedCart);
  };

  const handleTypeChange = (type) => {
    setSelectedType(type);
    if (type === 'All') {
      setFilteredProducts(products);
    } else {
      setFilteredProducts(products.filter(product => product.type === type));
    }
  };

  // Get all unique types for filter
  const types = Array.from(new Set(products.map(product => product.type))).filter(Boolean);

  return (
    <div>
      <div className='main'>
        {/* Left column: type filter */}
        <div className="column1">
          <h2 className="filter-heading">Types</h2>
          <ul className="filter-list">
            <li className="filter-category" onClick={() => handleTypeChange('All')}>All Merchandise</li>
            {types.map(type => (
              <li key={type} className="filter-category" onClick={() => handleTypeChange(type)}>{type}</li>
            ))}
          </ul>
        </div>
        {/* Center column: merchandise grid */}
        <div className="column2 catalog-grid">
          <div className="catalog-title">
            <h1>{selectedType === 'All' ? 'All Merchandise' : selectedType}</h1>
          </div>
          <div className="catalog-grid-row">
            {filteredProducts.map(product => (
              <div key={product.id} className="product-card">
                <h3 className="product-title">{product.name}</h3>
                <p className="product-description">{product.description}</p>
                <div className="product-image-wrapper">
                  {product.images && product.images.map((image, index) => (
                    <React.Fragment key={index}>
                      <img
                        src={process.env.PUBLIC_URL + image}
                        alt={`${product.name} ${index + 1}`}
                        className="product-img"
                      />
                      <br />
                    </React.Fragment>
                  ))}
                </div>
                <div className="product-details">
                  <strong className="product-type">{product.type}</strong>: {product.price} AUD
                  <br />
                  SKU: {product.sku}
                  <br />
                  Material: {product.material}
                  <br />
                  Color: {product.color}
                  <br />
                  Size: {product.size}
                  <br />
                  Category: {product.category}
                </div>
                <AddCartButton
                  item={product}
                  onAddToCart={addToCart}
                />
              </div>
            ))}
          </div>
        </div>
        {/* No third column */}
      </div>
    </div>
  );
};

export default Merchandise;